import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const RootContainer = styled.div`
	padding: 24px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const RulesContainer = styled.div`
	color: #818181 !important;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 32px;

  user-select: none; /* Disable text selection */
	-webkit-user-select: none; /* For Safari */
	-moz-user-select: none; /* For Firefox */
	-ms-user-select: none; /* For Internet Explorer/Edge */
	-webkit-touch-callout: none; /* Disable context menu on touch devices */
	-moz-touch-callout: none;
	-ms-touch-callout: none;
	-webkit-touch-callout: none;
`;


const Rules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	if (!state) {
		return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
	}

	const ruleText =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? state.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
			? state.text_mm
			: state.text_ch;
	return (
		<>
			<Topbar title={t("spin.rule")} goBack={goBack} shadow={false} />
			<RootContainer>
				{/* localization needed */}
				<RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
			</RootContainer>
		</>
	);
};

export default Rules;
